import { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { CDS_HIRCDR } from './theme';
import AppRoutes from './Routes';
import { ApplicationErrorBoundary } from './components/ErrorBoundary/ApplicationErrorBoundary';
import './App.css';
import './global.css';
import { NavProvider } from './context/NavContext';
import { ScrollToTop } from './components/Common/ScrollToTop';
import { useDispatch } from 'react-redux';
import { getUserInfo } from './store/actions/userInfo';

function App() {
  const [themeMode, setThemeMode] = useState('light'); // or 'dark'
  const dispatch = useDispatch();
  const handleThemeToggle = () => {
    setThemeMode(themeMode === 'light' ? 'dark' : 'light');
  };

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then(() => {
        const handleMessage = (event: any) => {
          if (event.data && event.data.type === 'NEW_NOTIFICATION') {
            dispatch(getUserInfo());
          }
        };
        navigator.serviceWorker.addEventListener('message', handleMessage);
      })
      .catch((error) => console.warn('Registration error', error));
  }

  const headerProps = {
    handleThemeToggle,
    themeMode
  };
  useEffect(() => {
    const handleContextMenu = (e: any) => {
      e.preventDefault();
    };
    const handleKeyDown = (e: any) => {
      // Disable F12, Ctrl+Shift+I, Ctrl+Shift+C, Ctrl+Shift+J, Ctrl+U for Windows/Linux
      // Disable F12, Cmd+Option+I, Cmd+Option+C, Cmd+Option+J, Cmd+U for Mac OS
      if (
        e.keyCode === 123 || // F12
        ((e.ctrlKey || e.metaKey) && e.shiftKey && e.keyCode === 73) || // Ctrl+Shift+I or Cmd+Option+I
        ((e.ctrlKey || e.metaKey) && e.shiftKey && e.keyCode === 67) || // Ctrl+Shift+C or Cmd+Option+C
        ((e.ctrlKey || e.metaKey) && e.shiftKey && e.keyCode === 74) || // Ctrl+Shift+J or Cmd+Option+J
        ((e.ctrlKey || e.metaKey) && e.keyCode === 85) // Ctrl+U or Cmd+U
      ) {
        e.preventDefault();
      }
    };
    if (process.env.REACT_APP_ENV == 'production') {
      document.addEventListener('contextmenu', handleContextMenu);
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  return (
    <ThemeProvider theme={CDS_HIRCDR(themeMode)}>
      <CssBaseline />
      <Router>
        <ScrollToTop /> {/* Here is the ScrollToTop component */}
        <div className="App">
          <ApplicationErrorBoundary>
            <NavProvider>
              <AppRoutes headerProps={headerProps} />
            </NavProvider>
          </ApplicationErrorBoundary>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
